export const OTP_LENGTH = 6;

// A digit typed or pasted into box `index`: it lands there, or right after the
// last digit when the box is past the end, and the focus moves on.
export function enterDigits(value, index, typed, length = OTP_LENGTH) {
  const digits = typed.replace(/\D/g, '');

  if (!digits) {
    return { value, focusIndex: index };
  }

  // A whole code (pasted, or autofilled) replaces what is there, wherever it
  // lands.
  const at = digits.length >= length ? 0 : Math.min(index, value.length);
  const next = (
    value.slice(0, at) +
    digits +
    value.slice(at + digits.length)
  ).slice(0, length);

  return {
    value: next,
    focusIndex: Math.min(at + digits.length, length - 1),
  };
}

// Backspace in box `index`: clears that box, or steps back and clears the
// previous digit when the box is empty.
export function removeDigit(value, index) {
  const at = Math.min(index, value.length);

  if (at < value.length) {
    return { value: value.slice(0, at) + value.slice(at + 1), focusIndex: at };
  }

  if (at === 0) {
    return { value, focusIndex: 0 };
  }

  return { value: value.slice(0, at - 1), focusIndex: at - 1 };
}

// What the user typed into a box that held `previous`: when the box was
// already filled, the browser hands back the old digit plus the new one.
export function typedDigits(previous, next) {
  if (previous && next.length === 2) {
    if (next[0] === previous) {
      return next.slice(1);
    }

    if (next[1] === previous) {
      return next.slice(0, 1);
    }
  }

  return next;
}
